export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-disabled-960-fcab8eb43d6651758233ae6315e2b398.png";